import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import moment from 'moment';
import { connect } from 'react-redux';
import Select from 'react-select';
import PropTypes from 'prop-types';
import DateInputPicker4 from 'modules/common/components/DateInputPicker4';

const SERVICES_SELECT = [
  { label: 'LAND', value: 'RPT_LAND' },
  { label: 'BUILDING', value: 'RPT_BUILDING' },
  { label: 'MACHINERY', value: 'RPT_MACHINERY' },
];

// default display on page render
const form = {
  period: 'MONTHLY',
  date_from: moment().startOf('year').format('YYYY-MM-DD'),
  date_to: moment().endOf('year').format('YYYY-MM-DD'),
  module_type: '',
};

const styles = {
  control: (base) => ({
    ...base,
    minHeight: 24,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
};

function SelectedDateFilterWithDropdown({ onSubmit }) {
  const [formData, setFormData] = useState(form);
  // const [toValue, setToValue] = useState(moment().format('YYYY-MM-DD'));
  // const [isChanged, setIsChanged] = useState(false);

  const handleChangeInput = (key, formKey) => (e) => {
    if (e.target.value) {
      const getTypeParams = (value) => {
        try {
          const paramsObject = {
            DAILY: () => {
              const args = {
                date_from: moment(e.target.value).format('YYYY-MM-DD'),
                date_to: moment(e.target.value).format('YYYY-MM-DD'),
              };
              return args;
            },
            MONTHLY: () => {
              let args = {};
              if (formKey === 'date_from') {
                args = {
                  [formKey]: moment(e.target.value).format('YYYY-MM-DD'),
                };
              }
              if (formKey === 'date_to') {
                args = {
                  [formKey]: moment(e.target.value).endOf('month').format('YYYY-MM-DD'),
                };
              }

              return args;
            },
            YEARLY: () => {
              let args = {};
              if (formKey === 'date_from') {
                args = {
                  [formKey]: moment(e.target.value).startOf('year').format('YYYY-MM-DD'),
                };
              }
              if (formKey === 'date_to') {
                args = {
                  [formKey]: moment(e.target.value).endOf('year').format('YYYY-MM-DD'),
                };
              }

              return args;
            },
          };

          return paramsObject[value] && paramsObject[value]();
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err, 'Something went wrong!');
          return {};
        }
      };

      setFormData({
        ...formData,
        ...getTypeParams(key),
      });
      onSubmit({
        ...formData,
        ...getTypeParams(key),
      });
    }
  };

  const filterMapper = {
    DAILY: () => (
      <div className="d-flex justify-content-between align-items-center my-3">
        <div className="d-flex justify-content-end  align-items-center">
          <div className="mr-1 d-flex align-self-center  align-items-center">
            <label className="mb-0 mr-1 align-self-center">Select Date</label>
            <div className="w-auto mr-3">
              <DateInputPicker4
                onChange={handleChangeInput('DAILY')}
                value={_.get(formData, 'date_from') || ''}
                maxDate={new Date()}
                dateFormat="MMMM, dd yyyy"
              />
            </div>
            {/* <span className="align-self-center mr-3 custom-text">To</span>
            <div className="w-auto">
              <DateInputPicker4
                onChange={handleChangeSecondPicker('daily')}
                value={isChanged ? toValue : _.get(formData, 'date_to')}
                dateFormat="MMMM, dd yyyy"
              />
            </div> */}
          </div>
        </div>
        {/* <div className="ml-1 mt-1">
          <button
            className="btn btn-sm btn-primary cms-bg-color-primary cms-outline-primary "
            onClick={handleOnSubmit}
            type="button"
          >
            Search
          </button>
        </div> */}
      </div>
    ),
    MONTHLY: () => (
      <div className="d-flex justify-content-between">
        <div className="d-flex justify-content-end">
          <div className="d-flex align-self-center">
            {/* <label className="mb-0 mr-1 align-self-center" /> */}
            <div className="w-auto mr-3">
              <DateInputPicker4
                onChange={handleChangeInput('MONTHLY', 'date_from')}
                value={_.get(formData, 'date_from') || ''}
                showMonthYearPicker
                dateFormat="MMMM, yyyy"
              />
            </div>
            <span className="align-self-center mr-3 custom-text">To</span>
            <div className="w-auto">
              <DateInputPicker4
                onChange={handleChangeInput('MONTHLY', 'date_to')}
                value={_.get(formData, 'date_to') || ''}
                showMonthYearPicker
                dateFormat="MMMM, yyyy"
              />
            </div>
          </div>
        </div>
        {/* <div className="ml-1 mt-1">
          <button
            className="btn btn-sm btn-primary cms-bg-color-primary cms-outline-primary "
            onClick={handleOnSubmit}
            type="button"
          >
            Search
          </button>
        </div> */}
      </div>
    ),
    YEARLY: () => (
      <div className="d-flex justify-content-between align-items-center">
        <div className="d-flex justify-content-end">
          <div className="mr-1 d-flex align-self-center">
            {/* <label className="label-transaction-card mb-0 mr-1 align-self-center" /> */}
            <div className="w-auto mr-3">
              <DateInputPicker4
                onChange={handleChangeInput('YEARLY', 'date_from')}
                value={_.get(formData, 'date_from') || ''}
                showYearPicker
                dateFormat="yyyy"
              />
            </div>
            <span className="align-self-center mr-3 custom-text">To</span>
            <div className="w-auto">
              <DateInputPicker4
                onChange={handleChangeInput('YEARLY', 'date_to')}
                value={_.get(formData, 'date_to') || ''}
                showYearPicker
                dateFormat="yyyy"
              />
            </div>
          </div>
        </div>
        {/* <div className="ml-1">
          <button
            className="btn btn-sm btn-primary cms-bg-color-primary cms-outline-primary "
            onClick={handleOnSubmit}
            type="button"
          >
            Search
          </button>
        </div> */}
      </div>
    ),
  };

  const setType = (period) => (e) => {
    e.preventDefault();
    // setIsChanged(false);

    const getTypeParams = (value) => {
      try {
        const paramsObject = {
          DAILY: () => {
            const args = {
              period: 'DAILY',
              date_from: moment(new Date()).format('YYYY-MM-DD'),
              date_to: moment(new Date()).format('YYYY-MM-DD'),
            };
            return args;
          },
          MONTHLY: () => {
            const args = {
              period: 'MONTHLY',
              date_from: moment().startOf('year').format('YYYY-MM-DD'),
              date_to: moment().endOf('year').format('YYYY-MM-DD'),
            };
            return args;
          },
          YEARLY: () => {
            const args = {
              period: 'YEARLY',
              date_from: moment().startOf('year').format('YYYY-MM-DD'),
              date_to: moment().endOf('year').format('YYYY-MM-DD'),
            };
            return args;
          },
        };

        return paramsObject[value] && paramsObject[value]();
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err, 'Something went wrong!');
        return {};
      }
    };

    setFormData({
      ...formData,
      ...getTypeParams(period),
    });

    onSubmit({
      ...formData,
      ...getTypeParams(period),
    });
  };

  const handleChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e.value,
    });

    onSubmit({
      ...formData,
      module_type: e.value,
    });
  };

  const { period } = formData;

  return (
    <>
      <div className="stat-header-container">
        <div className="stat-title">Statistics</div>
        <div className="stat-select">
          <Select
            styles={styles}
            placeholder="Select Service"
            value={
              SERVICES_SELECT.find(
                item => _.get(formData, 'module_type') === _.get(item, 'value')
              ) || ''
            }
            options={SERVICES_SELECT}
            onChange={handleChangeSelect('module_type')}
          />
        </div>
      </div>
      <div className="total-transaction-custom d-flex justify-content- mt-2">
        <ul className="nav">
          <li className="nav-item py-2 mx-2">
            <a
              className={`nav-link${period === 'DAILY' ? ' active active-btn-styles' : ''
                }`}
              href="/"
              onClick={setType('DAILY')}
            >
              Daily
            </a>
          </li>
          <li className="nav-item py-2 mx-2">
            <a
              className={`nav-link${period === 'MONTHLY' ? ' active active-btn-styles' : ''
                }`}
              href="/"
              onClick={setType('MONTHLY')}
            >
              Monthly
            </a>
          </li>
          <li className="nav-item py-2 mx-2">
            <a
              className={`nav-link${period === 'YEARLY' ? ' active active-btn-styles' : ''
                }`}
              href="/"
              onClick={setType('YEARLY')}
            >
              Yearly
            </a>
          </li>
        </ul>
      </div>
      <hr
        style={{
          color: '#4c6085',
          height: '0.5'
        }}
      />
      {filterMapper[period] && filterMapper[period]()}
    </>
  );
}

SelectedDateFilterWithDropdown.propTypes = {
  onSubmit: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(SelectedDateFilterWithDropdown);
